var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.07 16.5H12.93C15 16.5 15.825 15.2325 15.9225 13.6875L16.3125 7.4925C16.4175 5.8725 15.1275 4.5 13.5 4.5C13.0425 4.5 12.6225 4.2375 12.4125 3.8325L11.8725 2.745C11.5275 2.0625 10.6275 1.5 9.8625 1.5H8.145C7.3725 1.5 6.4725 2.0625 6.1275 2.745L5.5875 3.8325C5.3775 4.2375 4.9575 4.5 4.5 4.5C2.8725 4.5 1.5825 5.8725 1.6875 7.4925L2.0775 13.6875C2.1675 15.2325 3 16.5 5.07 16.5Z",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.875 6H10.125",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 13.5C10.3425 13.5 11.4375 12.405 11.4375 11.0625C11.4375 9.72 10.3425 8.625 9 8.625C7.6575 8.625 6.5625 9.72 6.5625 11.0625C6.5625 12.405 7.6575 13.5 9 13.5Z",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.91292024e4a494398be2f514da016e60.svg";
export { ForwardRef as ReactComponent };